// import { useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';

function useIdle({
  onIdle, onPrompt, idleTime, promptTime, toBeDisabled, onMessage
}) {
  const handleOnIdle = () => {
    onIdle(); // then call onIdle function
  };

  const handleOnPrompt = () => {
    onPrompt(); // then call onPrompt function
  };

  const parsedTimeout = Number(idleTime);
  const parsedPrompt = Number(promptTime);
  const safeTimeoutSeconds = Number.isFinite(parsedTimeout) && parsedTimeout > 1 ? parsedTimeout : 1;
  const maxPromptSeconds = Math.max(safeTimeoutSeconds - 1, 0);
  const safePromptSeconds = Number.isFinite(parsedPrompt) && parsedPrompt >= 0
    ? Math.min(parsedPrompt, maxPromptSeconds)
    : 0;

  const {
    getRemainingTime,
    isLeader,
    reset,
    message
  } = useIdleTimer({
    promptBeforeIdle: 1000 * safePromptSeconds,
    timeout: 1000 * safeTimeoutSeconds,
    events: [],
    onIdle: handleOnIdle,
    onPrompt: handleOnPrompt,
    disabled: toBeDisabled,
    onMessage,
    debounce: 500,
    crossTab: true,
    leaderElection: true,
    syncTimers: 20
  });
  return {
    getRemainingTime,
    isLeader,
    reset,
    message
  };
}

export default useIdle;
